import { css } from 'jimu-core';
export const userProfileStyles = (props) => {
    const theme = props.theme;
    return css `
    .header-account{
      .header-login {
        margin-right: 0;
      }
      circle{
        fill: ${theme.sys.color.secondary.light};
      }
      svg {
        color: ${theme.ref.palette.neutral[1000]};
      }
    }
  `;
};
